import { ArrowDown, ArrowUp, X } from 'lucide-react';

import type { JiraTransition } from '@/types';

export interface TransitionItemProps {
  transition: JiraTransition;
  index: number;
  isFirst: boolean;
  isLast: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRemove: () => void;
  disabled?: boolean;
}

export const TransitionItem = ({
  transition,
  index,
  isFirst,
  isLast,
  onMoveUp,
  onMoveDown,
  onRemove,
  disabled = false,
}: TransitionItemProps) => {
  return (
    <li className="border-chariot-stroke bg-chariot-background-secondary flex items-center gap-3 rounded-lg border p-3">
      <span className="bg-chariot-brand-primary/10 text-chariot-brand-primary flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full text-xs font-medium">
        {index + 1}
      </span>

      <div className="flex flex-1 flex-col gap-0.5">
        <span className="text-chariot-text-primary font-medium">
          {transition.name}
        </span>
        {transition.to && (
          <span className="text-chariot-text-secondary text-xs">
            → {transition.to.name}
          </span>
        )}
      </div>

      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={onMoveUp}
          disabled={disabled || isFirst}
          className="text-chariot-text-secondary hover:bg-chariot-background-tertiary hover:text-chariot-text-primary disabled:hover:text-chariot-text-secondary rounded-md p-1 transition-colors disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent"
          title="Move up"
        >
          <ArrowUp className="h-4 w-4" />
        </button>

        <button
          type="button"
          onClick={onMoveDown}
          disabled={disabled || isLast}
          className="text-chariot-text-secondary hover:bg-chariot-background-tertiary hover:text-chariot-text-primary disabled:hover:text-chariot-text-secondary rounded-md p-1 transition-colors disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent"
          title="Move down"
        >
          <ArrowDown className="h-4 w-4" />
        </button>

        <button
          type="button"
          onClick={onRemove}
          disabled={disabled}
          className="text-chariot-text-secondary hover:bg-chariot-status-critical/10 hover:text-chariot-text-red disabled:hover:text-chariot-text-secondary rounded-md p-1 transition-colors disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent"
          title="Remove"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </li>
  );
};
